import React, { useMemo } from "react"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import { useConfigDataState } from "../../globalStates/ConfigDataState"
import { ReferenceDataType, withReferenceDataState } from "../../globalStates/ReferenceDataHOC"
import Page from "../../components/Page"
import CategoriesContents from "./CategoriesContents"

const CategoriesPage: React.FC<ReferenceDataType> = ({ refDataState }) => {
    const branding = useLanguageState().getStrings()
    const selectedCategoriesStates = useExhibitorDataState().getCategories()

    const refCategories = useMemo(
        () => refDataState.getCategories("ORGANIZATION", branding.configuration.categoriesPage.categoryWhitelist),
        [branding.configuration.categoriesPage.categoryWhitelist, refDataState]
    )
    const serviceKeys = useConfigDataState().getServiceKeys()

    return (
        <Page description={branding.configuration.categoriesPage.pageDescription}>
            <CategoriesContents
                selectedCategoriesStates={selectedCategoriesStates}
                refCategories={refCategories}
                limit={serviceKeys.category}
                countableCategories={branding.configuration.countableCategories.categoriesCountableCategories}
            />
        </Page>
    )
}

export default React.memo(withReferenceDataState(CategoriesPage))
